module.exports = __webpack_public_path__ + "img/tu01.2b808270.png";